<template>
  <div id="AddCouponDialog">
    <el-dialog
      title="优惠券生成并发放"
      width="540px"
      :visible.sync="isVisibleTemp"
      @close="closeAndclear('couponInfo')"
    >
      <el-form
        :model="couponInfo"
        :rules="rules"
        ref="couponInfo"
      >
        <el-form-item
          label="优惠券名称"
          :label-width="formLabelWidth"
          prop="couponName"
        >
          <el-input
            v-model="couponInfo.couponName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="优惠券类型"
          :label-width="formLabelWidth"
          prop="couponType"
        >
          <el-select
            v-model="couponInfo.couponType"
            clearable
            placeholder="请选择优惠券类型"
          >
            <el-option
              label="现金"
              value="1"
            ></el-option>
            <el-option
              label="折扣"
              value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="优惠金额/折扣"
          :label-width="formLabelWidth"
          prop="discountAmount"
        >
          <el-input
            class="eb-input panel-body-row-right"
            v-model="couponInfo.discountAmount"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="折扣起点"
          :label-width="formLabelWidth"
          prop="discountStart"
        >
          <el-input
            class="eb-input panel-body-row-right"
            v-model="couponInfo.discountStart"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="使用的业务类型"
          :label-width="formLabelWidth"
          prop="businessType"
        >
          <el-select
            v-model="couponInfo.businessType"
            clearable
            placeholder="请选择业务类型"
          >
            <el-option
              label="通用"
              value="TY2018"
            ></el-option>
            <el-option
              label="实名认证"
              value="SMRZ1804"
            ></el-option>
            <el-option
              label="商机推送"
              value="SJTS1804"
            ></el-option>
            <el-option
              label="合规鉴证"
              value="HGJZ1808"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="生效时间"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="couponInfo.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="生效日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="过期时间"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="couponInfo.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="过期日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="eb-button-group-btn eb-button-orange eb-button-big"
          @click="closeAndclear('couponInfo')"
        >关闭</el-button>
        <el-button
          class="eb-button-group-btn eb-button-orange eb-button-big"
          @click="addCoupon"
        >确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { saveCoupon } from '@/services/coupon/coupon-service';
export default {
  props: {
    couponInfo: {
      type: Object
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formLabelWidth: '130px',
      rules: {
        couponName: [{ required: true, message: '请输入优惠券名称', trigger: 'blur' }],
        couponType: [{ required: true, message: '请选择优惠券类型', trigger: 'blur' }],
        discountAmount: [{ required: true, message: '请输入折扣金额', trigger: 'blur' }],
        businessType: [{ required: true, message: '请选择使用类型', trigger: 'blur' }]
      }
    };
  },
  computed: {
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  methods: {
    // 生成并发放优惠券
    addCoupon() {
      console.info('选中的用户id' + this.couponInfo.couponUserIds);
      this.$refs['couponInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await saveCoupon(this.couponInfo);
            if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$confirm('添加成功，本次发放优惠券条数为' + data.couponCount, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'eb-cancle-button',
                cancelButtonClass: '',
                type: '',
                center: true,
                showClose: false,
                customClass: 'eb-comfirm',
                showCancelButton: false
              });
              this.$emit('addCouponClose');
            } else {
              this.$message.error('添加失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    closeAndclear(couponInfo) {
      this.isVisibleTemp = false;
      this.$refs[couponInfo].resetFields();
      this.$emit('addCouponClose');
    }
  }
};
</script>
